import { GlobalConfig } from "@common/utils";

import { Defaults } from "@common/_constants/defaults.constants";
import { Format } from "@common/_constants/format.constants";
import { JobType } from "@common/_constants/job.constants";
import { Routing } from "@common/_constants/routing.constants";
import { Search } from "@common/_constants/search.constants";
import { SMSOptType } from "@common/_constants/smsOptions.constants";
import { Social } from "@common/_constants/social.constants";
import { Tracking } from "@common/_constants/tracking.constants";
import { UserConstants } from "@common/_constants/user.constants";

export const constants = {
    GlobalConfig,
    Routing,
    Defaults,
    Format,
    JobType,
    Search,
    SMSOptType,
    Social,
    Tracking,
    User: UserConstants,
}

export * from "./defaults.constants";
export * from "./format.constants";
export * from "./job.constants";
export * from "./routing.constants";
export * from "./search.constants";
export * from "./smsOptions.constants";
export * from "./social.constants";
export * from "./tracking.constants";
export * from "./user.constants";
